import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';
import { formatCount } from '@/utils/format';

const sorted = [...novels].sort((a, b) => b.updateTime.localeCompare(a.updateTime)).slice(0, 8);

export default function LatestUpdates() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="mb-7 flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">追更不错过，最新章节第一时间呈现</p>
          </div>
        </div>

        <ul className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {sorted.map((novel, i) => (
            <li key={novel.id}>
              <Link
                to={`/detail/${novel.id}`}
                className={`group flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-primary-50 md:px-6 ${
                  i !== 0 ? 'border-t border-background-100' : ''
                }`}
              >
                <div className="h-16 w-12 shrink-0 overflow-hidden rounded bg-background-200">
                  <img
                    src={novel.cover}
                    alt={`${novel.title}封面`}
                    title={`${novel.title}小说封面`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
                      {novel.title}
                    </span>
                    <span className="rounded-full bg-primary-100 px-2 py-0.5 text-xs text-primary-700">
                      {novel.category}
                    </span>
                    <span className="hidden text-xs text-foreground-400 sm:inline">
                      {novel.author}
                    </span>
                  </div>
                  <p className="mt-1.5 flex items-center gap-1.5 truncate text-xs text-foreground-600">
                    <i className="ri-book-open-line text-accent-500"></i>
                    更新至 {novel.latestChapter}
                  </p>
                </div>
                <div className="hidden shrink-0 flex-col items-end text-xs text-foreground-400 md:flex">
                  <span className="whitespace-nowrap">{novel.updateTime}</span>
                  <span className="mt-1.5 flex items-center gap-1 text-foreground-500">
                    <i className="ri-bookmark-line"></i>
                    {formatCount(novel.favorites)}
                  </span>
                </div>
                <span className="shrink-0 text-xs text-foreground-400 md:hidden">
                  {novel.updateTime.slice(5, 10)}
                </span>
              </Link>
            </li>
          ))}
        </ul>

        <div className="mt-6 flex justify-center">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50"
          >
            浏览完整更新列表
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}